<template>
  <memlist-card>

    <div class="d-flex justify-end">
      <memlist-icon-button
        class="mb-2"
        icon="menu-icon flaticon2-plus"
        text="Nytt SMS"
        variant="primary"
        @click="createSMSClicked"
      />
    </div>

    <m-row>
      <m-col cols="6" >
      
        <div class="bottom-alignment">
          <strong>{{ $t('MEMBER.NUM_ROWS') }}:</strong> {{ total_rows }}
        </div>

      </m-col>
      <m-col cols="6">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
            aria-controls="advance-file-table"
          />

        </div>
      </m-col>
    </m-row>


    <memlist-static-table
      id="sms-table"
      :fields="headers"
      :items="smss"
      :per_page="per_page"
      :current_page="current_page"
      head-variant="light"
      class="mh-100"
      sticky-header
    >


      <template #cell(company_id)="row">
        <div class='justify-content-end d-flex'>

          <a
            href="#"
            class="btn btn-icon btn-light btn-sm mx-3"
            @click="selectSMSClicked(row.item.sms_id)"
          >
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <inline-svg src="/assets/svg/pencil-square.svg"></inline-svg>
            </span>
          </a>

        </div>
      </template>
    </memlist-static-table>
  </memlist-card>

</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: "SMSTable",
  props: ["smss"],
  emits: ['createSMSClicked', 'selectSMSClicked', 'deleteSMSClicked'],
  components: {
    
  },
  mixins: [ toasts ],
  watch: {

  },
  computed:{
    ...mapGetters([]),
    total_rows() {
      return this.smss.length;
    }
  },
  mounted() {

  },
  methods: {
    createSMSClicked() {
      this.$emit('createSMSClicked');
    },
    selectSMSClicked(id) {
      this.$emit('selectSMSClicked', id);
    },
    deleteSMSClicked(id) {
      this.$emit('deleteSMSClicked', id);
    },
  },
  data() {
    return {
      showAll: false,
      current_page: 1,
      per_page: 100,
      options: [
        100, 150, 200
      ],
      headers: [
        {
          key: 'sms_id',
          label: 'ID',
          sortable: true,
          thClass: 'pl-7 align-middle',
          tdClass: 'pl-7 align-middle'
        },
        {
          key: 'to_number',
          label: 'Till',
          sortable: true,
          thClass: 'pl-7 align-middle',
          tdClass: 'pl-7 align-middle'
        },
        {
          key: 'sent_at',
          label: 'Datum',
          thClass: 'w-165px align-middle',
          tdClass: 'w-165px align-middle',
          sortable: true
        },
        {
          key: 'company_id',
          label: 'Hantera',
          thClass: 'w-120px text-right pr-12 align-middle',
        },
      ]
    };
  }
};
</script>
